.button {
  --btn-bg: transparent;
  --btn-bg-hover: transparent;
  --btn-bg-active: transparent;
  --btn-fg: var(--color-text);
  --btn-border: transparent;

  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--layout-control-height-md);
  padding: 0 var(--space-4);
  border: 1px solid var(--btn-border);
  border-radius: var(--radius-md);
  background-color: var(--btn-bg);
  color: var(--btn-fg);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  user-select: none;
  transition:
    background-color var(--duration-fast) var(--ease-out),
    border-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out),
    box-shadow var(--duration-fast) var(--ease-out);
}

.button:hover:not(:disabled, [aria-disabled='true']) {
  background-color: var(--btn-bg-hover);
}

.button:active:not(:disabled, [aria-disabled='true']) {
  background-color: var(--btn-bg-active);
}

.button:disabled,
.button[aria-disabled='true']:not(.loading) {
  opacity: 0.55;
  cursor: not-allowed;
}

.loading {
  cursor: progress;
}

.primary {
  --btn-bg: var(--color-primary);
  --btn-bg-hover: var(--color-primary-hover);
  --btn-bg-active: var(--color-primary-active);
  --btn-fg: var(--color-primary-contrast);
  box-shadow: var(--shadow-xs);
}

.secondary {
  --btn-bg: var(--color-surface);
  --btn-bg-hover: var(--color-surface-hover);
  --btn-bg-active: var(--color-surface-sunken);
  --btn-fg: var(--color-text);
  --btn-border: var(--color-border-strong);
  box-shadow: var(--shadow-xs);
}

.ghost {
  --btn-bg-hover: var(--color-surface-hover);
  --btn-bg-active: var(--color-surface-sunken);
  --btn-fg: var(--color-text-muted);
}

.ghost:hover:not(:disabled, [aria-disabled='true']) {
  color: var(--color-text);
}

.danger {
  --btn-bg: var(--color-danger-solid);
  --btn-bg-hover: var(--color-danger-solid-hover);
  --btn-bg-active: var(--color-danger-solid-hover);
  --btn-fg: var(--color-danger-contrast);
  box-shadow: var(--shadow-xs);
}

.link {
  --btn-fg: var(--color-link);
  min-height: auto;
  padding: 0;
  border: 0;
  font-weight: var(--font-weight-medium);
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 0.18em;
}

.link:hover:not(:disabled, [aria-disabled='true']) {
  background-color: transparent;
  color: var(--color-link-hover);
  text-decoration-color: currentColor;
}

.sm {
  min-height: var(--layout-control-height-sm);
  padding: 0 var(--space-3);
  font-size: var(--font-size-sm);
  gap: var(--space-1-5);
}

.lg {
  min-height: var(--layout-control-height-lg);
  padding: 0 var(--space-5);
  font-size: var(--font-size-lg);
}

.link.sm,
.link.lg {
  min-height: auto;
  padding: 0;
}

.fullWidth {
  width: 100%;
}

.icon {
  display: inline-flex;
  flex-shrink: 0;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (forced-colors: active) {
  .button {
    border-color: ButtonText;
  }
}
